// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2EYiy","label":"Completed_label__JSH4v"};